import { createAction } from '@reduxjs/toolkit';

export const fileUploadStart = createAction<string | null>('fileUploadStart');
export const fileUploadFinish = createAction<string | null>('fileUploadFinish');
